<template>
  <el-dialog :title="title" :visible="true" width="95%" :before-close="close">
    <el-table :data="tableData" v-loading="tableLoading" border>
      <el-table-column type="index" label="序号" />
      <el-table-column
        align="center"
        v-bind="item"
        v-for="item in tableColumns"
        :prop="item.prop"
        :label="item.label"
      >
        <!--自定义渲染行-->
        <template slot-scope="scope">
          <col-render :scope="scope" :col="item" :render="item.render" />
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import { dianziContractList, invoice } from '@/api/ajax';
import { colRender } from '@/components/Base/baseTable';
import { moneyFixed } from '@/tools/money';
import look from './detail.park.look';
import createExtend from '@C/createExtend';

export default {
  name: 'invoice-detail-park',
  components: { colRender },
  // components: { BaseTable, BasePagination },
  // mixins: [baseTableMixin],
  props: {
    title: {
      type: String,
      default: ''
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableData: [],
      tableColumns: [
        { label: '个体', prop: 'allianceUserEnterpriseName' },
        { label: '经营者', prop: 'fullName' },
        { label: '手机号', prop: 'phone' },
        {
          label: '开票金额（元）',
          prop: 'invoicePrice',
          formatter(v) {
            return moneyFixed(v);
          }
        },
        {
          label: '开票状态',
          prop: 'invoiceStatus',
          formatter(v) {
            if(+v === 2){
              return '已开票'
            }
            return '待开票';
          }
        },
        {
          label: '操作',
          render: (h, { scope: { row, _self } }) => {
            return h(
              'el-button',
              {
                props: {
                  type: 'text',
                  disabled: !row.imgList.length
                },
                on: {
                  click: () => {
                    createExtend(look, {
                      title: '发票详情（园区）',
                      row
                    });
                  }
                }
              },
              '查看'
            );
          }
        }
      ],
      tableLoading: false
    };
  },
  methods: {
    close() {
      this.remove();
    },
    // 初始 表格列表数据
    _initTableData() {
      if (this.tableLoading) return;
      this.tableLoading = true;
      this.$nextTick(async () => {
        const params = Object.assign(
          {},
          this.tableSearchParams,
          this.tablePageQuery
        );
        const { id } = this.row;
        const {
          data: { data }
        } = await invoice.queryInvoiceDetail({
          id
        });

        this.tableData = data;
        // this.tableTotal = total;
        this.tableLoading = false;
      });
    }
  },
  async created() {
    this._initTableData();
  }
};
</script>
<style lang="scss" scoped>
.picBox {
  padding: 0 30px 30px;
  border-radius: 12px;

  img {
    border: 1px solid #979797;
    width: 973px;
  }

  .btnBox {
    margin: auto;
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    width: 60%;
  }
}

.colorBlock {
  font-size: 20px;
  line-height: 25px;
  display: flex;
  font-weight: bold;
}

.colorBlock::before {
  content: '';
  width: 10px;
  height: 25px;
  background: #1989fa;
  margin-right: 5px;
  display: inline-block;
}

.shadowBox {
  width: 1060px;
  padding: 15px 0;
  background: #f5f7fa;
  margin-bottom: 80px;
  margin-left: 50px;
}

.box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 20px;

  > div {
    display: flex;
    align-items: center;
    margin-right: 130px;
    margin-bottom: 20px;
  }

  label {
    color: #333333;
    font-size: 14px;
    width: 150px;
  }

  img {
    width: 174px;
    height: 112px;
  }

  .picInput {
    width: 174px;
    box-sizing: border-box;
  }

  li {
    margin-right: 48px;
  }
}

.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #efefef;
  width: 100%;
  margin-bottom: 40px;

  .left {
    color: #9b9b9b;
    font-size: 20px;
  }

  .right {
    font-size: 14px;
    color: #9b9b9b;
  }
}

.radioGroup {
  display: flex;
  margin-top: 20px;
  justify-content: flex-start;
}
</style>
